import * as React from 'react';
import logo from '../../../images/iv_footer.svg';
import styled from '@emotion/styled';

const FooterContainer = styled.div`
  position: relative;
  height: 5.5%;
  background-color: #E9E8E8;
  border-top: 2px solid #E1E0E0;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const FooterList = styled.ul`
  margin: 0;
  padding: 0;
  font-size: 0.7vw;
  color: #929598;
  display: flex;

  a {
    color: #929598;
  }
  
`;

const FooterElement = styled.li`
  list-style-type: none;
&:after {
    margin: 0 5px;
    content: "|";
  }
  &:last-child:after {
      content: "";
    }
`;

export const Footer: React.FC = React.memo(() => {
  return <FooterContainer>
    <FooterList>
      <FooterElement>
        Copyright © Innovid Inc. All Rights Reserved
      </FooterElement>

      <FooterElement>
        <a href="https://www.innovid.com/terms-of-use">
          Terms Of Use
        </a>
      </FooterElement>

      <FooterElement>
        <a href="mailto:support@innovid.com?subject=Innovid Preview Support">
          Support
        </a>
      </FooterElement>
    </FooterList>
    <div
      style={{
        position: 'absolute',
        right: '2%',
        alignItems: 'center',
        width:'5%',
        height:"45%",
        backgroundSize:"contain",
        backgroundRepeat:"no-repeat",
        backgroundImage:`url(${logo})`
      }}/>
  </FooterContainer>;
});
